export default __webpack_public_path__ + "static/media/CS-RZ25WKRW.1aeebea3.jpg";